import classNames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Navbar } from 'shards-react';
import { toggleSidebar } from './sidebarActions';
import SidebarNavItems from './SidebarNavItems';

const mapState = state => ({
  toggleStatus: state.toggleStatus.toggleStatus
});

const actions = {
  toggleSidebar
};

class MainSidebar extends Component {
  state = {
    hideLogoText: false
  };
  render() {
    const classes = classNames(
      'main-sidebar',
      'px-0',
      'col-12',
      this.props.toggleStatus && 'open'
    );
    const { toggleSidebar } = this.props;

    return (
      <Col tag='aside' className={classes} lg={{ size: 2 }} md={{ size: 2 }}>
        <div className='main-navbar'>
          <Navbar
            className='align-self-center bg-white d-md-none  flex-md-nowrap d-lg-none border-bottom p-0'
            type='light'
          >
            <a
              className='toggle-sidebar d-sm-inline d-md-none d-lg-none m-auto '
              onClick={toggleSidebar}
            >
              <i className='material-icons'>close</i>
            </a>
          </Navbar>
        </div>
        <SidebarNavItems />
      </Col>
    );
  }
}

export default connect(mapState, actions)(MainSidebar);
